module.exports = __webpack_public_path__ + "img/blood_slash.fdf0aaf2.jpg";